import { Cascader } from 'antd';

export default Cascader;
